var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from '../../styled';
import * as Checkbox from '../choice/Checkbox';
import * as ClearButton from '../button/ClearButton';
const StyledWrapper = styled.div `
  display: inline-block;
  box-shadow: 0 0.0625rem 0.125rem 0.0625rem rgba(54, 62, 81, 0.1);
  border-radius: 6px;
  > :not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  > :not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  > * {
    padding: 0 1rem;
  }
`;
export const Wrapper = React.memo(({ children }) => {
    return React.createElement(StyledWrapper, null, children);
});
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const generateStyle = () => {
    return css `
    margin: 0; // overwrite safari user agent style
    :not(:first-child):before {
      content: '';
      border-left: 0.0625rem solid ${({ theme }) => theme.colors.INK_200};
      position: absolute;
      height: 2.125rem;
      left: 0;
      top: 50%;
      transform: translate(0, -50%);
    }
  `;
};
export const DefaultButton = React.memo(styled(ClearButton.Default) `
  ${generateStyle()} :not(:first-child) {
    :before {
      border-left-color: ${({ theme }) => theme.colors.INK_200};
    }
    :active:not(:disabled):before {
      border-left-color: ${({ theme }) => theme.colors.PRIMARY_400};
    }
  }
  :hover:not(:disabled) * {
    color: ${({ theme }) => theme.colors.PRIMARY_500};
    fill: ${({ theme }) => theme.colors.PRIMARY_500};
  }
  :active:not(:disabled) * {
    color: ${({ theme }) => theme.colors.PRIMARY_700};
    fill: ${({ theme }) => theme.colors.PRIMARY_700};
  }
`);
export const DestructiveButton = React.memo(styled(ClearButton.Destructive) `
  ${generateStyle()} :not(:first-child) {
    :before {
      border-left-color: ${({ theme }) => theme.colors.INK_200};
    }
    :active:not(:disabled):before {
      border-left-color: ${({ theme }) => theme.colors.RED_300};
    }
  }
  :hover:not(:disabled) * {
    color: ${({ theme }) => theme.colors.RED_400};
    fill: ${({ theme }) => theme.colors.RED_400};
  }
  :active:not(:disabled) * {
    color: ${({ theme }) => theme.colors.RED_700};
    fill: ${({ theme }) => theme.colors.RED_700};
  }
`);
export const TabButton = React.memo(styled(ClearButton.Default) `
  ${generateStyle()}
  ${({ active }) => active &&
    css `
      :not(:disabled),
      :hover:not(:disabled) {
        background-color: ${({ theme }) => theme.colors.PRIMARY_600};
        * {
          color: ${({ theme }) => theme.colors.SNOW_100};
          fill: ${({ theme }) => theme.colors.SNOW_100};
        }
      }
    `}
    ${({ active }) => !active &&
    css `
        :hover:not(:disabled) * {
          color: ${({ theme }) => theme.colors.PRIMARY_500};
          fill: ${({ theme }) => theme.colors.PRIMARY_500};
        }
      `}
  :active:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.PRIMARY_600};
    * {
      color: ${({ theme }) => theme.colors.SNOW_100};
      fill: ${({ theme }) => theme.colors.SNOW_100};
    }
  }
  
`);
const StyledCheckboxButton = styled(DefaultButton) `
  padding-left: 0.5rem;
  &:hover input[type='checkbox'] + div {
    border: 0.0625rem solid ${({ theme }) => theme.colors.PRIMARY_600};
  }
`;
const ContentWrapper = styled.span `
  display: inline-flex;
  align-items: center;
  > *:first-child {
    margin-right: 0.5rem;
  }
  ${({ checked }) => checked &&
    css `
      color: ${({ theme }) => theme.colors.PRIMARY_600};
      fill: ${({ theme }) => theme.colors.PRIMARY_600};
    `}
`;
export const CheckboxButton = React.memo((_a) => {
    var { children, onChange, isError, interminate, checked } = _a, restProps = __rest(_a, ["children", "onChange", "isError", "interminate", "checked"]);
    return (React.createElement(StyledCheckboxButton, Object.assign({}, restProps),
        React.createElement(ContentWrapper, { checked: checked },
            React.createElement(Checkbox.Default, { checked: checked, interminate: interminate, isError: isError, onChange: onChange }),
            children)));
});
//# sourceMappingURL=ButtonGroup.js.map